<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                    <div class="form-group">
                        <label for="id">{{ temporadaLabel }}</label>
                        <ValidationProvider name="ID" rules="required" v-slot="{ errors }">
                            <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="temporadaLabel" v-model="n_abonado_antiguo" />
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label for="pin">{{ $t('partidos.lfp_4_cifras') }}</label>
                        <ValidationProvider name="pin" rules="required" v-slot="{ errors }">
                            <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('partidos.lfp_4_cifras')" v-model="pin" />
                        </ValidationProvider>
                    </div>
                    
                    <button type="submit" class="button large-button effect-button"><span>{{ $t('renovar_abono.renovar') }}</span></button>
                </ValidationObserver>
            </div>
            <div class="col-12 mt-3" v-if="error">
                <div class="alert alert-danger" role="alert">
                    <p class="mb-0">{{ error }}</p>
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import { useOldSeasonLabel } from '@/composables/common/useOldSeasonLabel';

    export default {        
        data() {
            return {
                dni: '',
                loading: false,
                error: false,
                n_abonado_antiguo: '',
                pin: ''
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
            temporadaLabel() {
                return useOldSeasonLabel();
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.buscarAbonado();
                }
            },
            terminar() {
                this.$emit('terminado', {
                    n_abonado_antiguo: this.n_abonado_antiguo,
                    pin: this.pin
                });
            },
            buscarAbonado() {
                this.loading = true;

                const params = {
                    tid: this.configuracion.hash_teatro,
                    dni: this.dni,
                    pin: this.pin,
                    n_abonado_antiguo: this.n_abonado_antiguo
                }

                this.$store.dispatch(this.config.getVuexAlias('lfp.buscar.abono'), params).then(res => {
                    this.loading = false;
                    this.$emit('terminado', res.data);
                    this.$emit('documentacion', {
                        solicitar_documentacion: !!res.data.solicitar_documentacion,
                        texto_documentacion: res.data.texto_documentacion || ''
                    });
                }).catch(error => {
                    this.loading = false;
                    this.error = error.response.data.message;
                    if(error.response.data.message == 'Nº de abonado o dni incorrecto.' && this.configuracion.hash_teatro == 'akr1V2vNbDdxA3CkLniS') {
                        this.error = 'Nº de ID o PIN incorrecto. Por favor escriba a abonados@albacetebalompie.com con su Nombre, apellidos y DNI';
                    }
                    if(error.response.data.message == 'Nº de abonado o dni incorrecto.' && this.configuracion.hash_teatro == 'I0QtpDfZsTkgWKert1Gp') {
                        this.error = 'Nº ID o PIN incorrecto.';
                    }
                });
            },
        },
        components: {
            ContentOrLoading
        }
    }
</script>
